import axios from "axios";
import { supabase } from "../config/supabase";
import API_BASE_URL from "../apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Attach the Supabase access token to every outgoing request. The supabase-js
// client transparently refreshes expired access tokens before returning the
// session, so we don't need our own retry logic here.
apiClient.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
